import esContent from './gatorBackup.es';

export default {
  ...esContent,
};
